/* Sticky add-to-cart bar.
   Watches the inline add-to-cart submit button. When it scrolls out of view,
   slide the sticky bar up. Tapping the sticky button programmatically clicks
   the inline button so all form values (qty, variant, properties[*],
   selling_plan) are submitted as the user filled them in. */

class StickyAtc extends HTMLElement {
  constructor() {
    super();
    this.button = this.querySelector('[data-sticky-atc-button]');
    this.priceEl = this.querySelector('[data-sticky-atc-price]');
    this.mobileOnly = this.dataset.mobileOnly === 'true';
    this.targetButton = null;
    this.observer = null;

    this.init = this.init.bind(this);
    this.onClick = this.onClick.bind(this);
    this.onIntersect = this.onIntersect.bind(this);
    this.syncPrice = this.syncPrice.bind(this);

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', this.init);
    } else {
      this.init();
    }
  }

  init() {
    this.targetButton = document.querySelector('product-info .product-form__submit, product-info button[name="add"]');
    if (!this.targetButton) return;

    this.button.addEventListener('click', this.onClick);

    this.observer = new IntersectionObserver(this.onIntersect, { rootMargin: '0px 0px -40px 0px' });
    this.observer.observe(this.targetButton);

    document.addEventListener('variant:change', this.syncPrice);
    document.addEventListener('on:variant:change', this.syncPrice);
    new MutationObserver(this.syncPrice).observe(
      document.querySelector(`#price-${this.findSectionId()}`) || document.body,
      { childList: true, subtree: true, characterData: true }
    );
  }

  findSectionId() {
    const wrap = document.querySelector('product-info[data-section]');
    return wrap ? wrap.dataset.section : '';
  }

  onIntersect(entries) {
    entries.forEach((entry) => {
      const shouldShow = !entry.isIntersecting;
      this.classList.toggle('is-visible', shouldShow);
      this.setAttribute('aria-hidden', shouldShow ? 'false' : 'true');
    });
  }

  onClick(e) {
    e.preventDefault();
    if (this.targetButton && !this.targetButton.disabled) {
      this.targetButton.click();
    }
  }

  syncPrice() {
    if (!this.priceEl) return;
    const inlinePrice = document.querySelector(`#price-${this.findSectionId()} .price-item--regular, #price-${this.findSectionId()} .price-item--last`);
    if (inlinePrice) {
      this.priceEl.textContent = inlinePrice.textContent.trim();
    }
    if (this.targetButton && this.targetButton.disabled) {
      this.button.disabled = true;
      this.button.classList.add('is-disabled');
    } else {
      this.button.disabled = false;
      this.button.classList.remove('is-disabled');
    }
  }
}

if (!customElements.get('sticky-atc')) {
  customElements.define('sticky-atc', StickyAtc);
}
